<template>
    <div class="one-box">
        <div class="one-title">热销产品销售占比</div>
        <div class="one-part-box">
          
 <div class="content">
        <j-3D-swipe
             maxWidth="180px"
            :imgList="imgList"
            :blurPause="false"
            :autoPlay="true"
            multiple="1.1"
        ></j-3D-swipe>
    </div>
        </div>
    </div>

</template>

<script>
export default {
data() {
    return {
      imgList:[
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/b5b20202403191608178436.png',
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/c67c9202403191608564494.png',
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/2fc23202403191609272021.png',
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/8a695202403191609594448.png',
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/f0cb1202403191610532070.png',
        'https://jshz-hotel.ks3-cn-beijing.ksyuncs.com/f365f202403191611179783.png',
  

      ]
    };
  },
}
</script>

<style>
.content{
  width: 100%;
  height: 100%;
}
  .el-carousel__item h3 {
   
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .medium{
    text-align: center;
  }
  .bannerImg {
  height: 100% !important;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.banner_img {
  position: relative;
}

.zhezhao p {
  line-height: 1vh;
  color: #fff;
  /* text-align: left; */
  padding-left: 1vw;

}

.zhezhao {
  width: 100%;
  height: 4vh;
  position: absolute;
  bottom: -1vh;
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* 遮罩层、 */
  	backdrop-filter:saturate(150%) blur(8px);
	-webkit-backdrop-filter:saturate(150%) blur(8px);
	background-color:rgba(0,0,0,0.5);


}
</style>


// WEBPACK FOOTER //
// src/views/moudles/ProductMoudle.vue